/**
 * @fileoverview A moldura dos modais das telas novas (o assistente da IA, os
 * convites da equipe): o papel com borda fina, o cabeçalho com título, texto e
 * fechar, e o rodapé com as ações, nos tons neutros das telas de entrada. Cada
 * tela põe a largura dela e o próprio corpo.
 */

/** As classes da moldura para um makeStyles: `...dialogShell(theme, { width: 520 })`. */
export const dialogShell = (theme, { width }) => {
  const dark = theme.palette.type === "dark";
  const text = dark ? "#FAFAFA" : "#09090B";
  const muted = dark ? "#A1A1AA" : "#52525B";
  const line = dark ? "rgba(255,255,255,0.08)" : "#E4E4E7";
  return {
    // "&&": o fundo do Paper do tema (com transparência) venceria a classe empatada.
    // A margem de 16px deixa o modal inteiro na largura do celular.
    dialogPaper: {
      "&&": {
        width: `min(${width}px, calc(100vw - 32px))`, maxWidth: "calc(100vw - 32px)", margin: 16, borderRadius: 16,
        background: dark ? "#141416" : "#FFFFFF", color: text, border: `1px solid ${line}`,
        boxShadow: dark ? "0 24px 64px rgba(0,0,0,0.5)" : "0 24px 64px rgba(24,24,27,0.14)", backgroundImage: "none",
      },
    },
    dialogHead: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, padding: "20px 22px 14px", borderBottom: `1px solid ${line}` },
    dialogTitle: { margin: 0, fontSize: 18, fontWeight: 700, color: text },
    dialogText: { margin: "4px 0 0", fontSize: 13.5, lineHeight: 1.5, color: muted },
    dialogClose: { color: muted },
    dialogFoot: { display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 10, padding: "14px 22px 18px", borderTop: `1px solid ${line}` },
  };
};
